import React, {useEffect, useState} from 'react';
import {Modal, Table} from "react-bootstrap";
import BlockUi from "@availity/block-ui";
import axios from "../../../helpers/axios";
import moment from "moment";
import SearchSelect from "../../../components/searchSelect";
import CustomDatePicker from "../../base/components/forms/customDatePicker";
import {useController, useForm} from "react-hook-form";
import LoadingButton from "../../base/components/loadingButton";
import _ from 'lodash'
import numberFormat from "../../../helpers/numberFormat";
import {connect} from "react-redux";
import Pagination from "../../../components/paginaton";
import {noDispHeader} from "../../../helpers/errorTranslate";
import sayError from "../../../helpers/sayError";


const fields = [
  {label:'Пассажир', value:'mainPax'},
  {label:'Комиссия', value:'commission'},
  {label:'КрсКаяр', value:'krsKayar'},
  {label:'Индивидуальный код', value:'idInOneC'},
  {label:'Поставщик', value:'supplierNew'},
  {label:'Валюта', value:'currency'},
  {label:'Курс', value:'exchangeRate'},
  {label:'Дата начала', value:'startDate'},
  {label:'Дата окончания', value:'endDate'},
  {label:'Сумма Вал', value:'summCurrency'},
  {label:'Сумма KZT', value:'summKZT'},
  {label:'Номер билета', value:'ticketNumber'},
  {label:'Авиакомпания', value:'airline'},
  {label:'Дата выписки', value:'issuedDate'},
  {label:'Пассажир', value:'paxName'},
  {label:'Тариф', value:'fare'},
  {label:'Таксы', value:'taxes'},
  {label:'Штрафы', value:'penalties'},
  {label:'КРС клиента', value:'krsBuyer'},
  {label:'КРС поставщика', value:'krsSeller'},
  {label:'КРС Каяр', value:'krsKayar'},
  {label:'Возврат', value:'refund'},
  {label:'Пред.билет', value:'prevTicket'},
  {label:'Комментарий', value:'serviceComment'},
  {label:'Технический контрагент', value:'technicalCounterparty'},
  {label:'Без документов', value:'issuedWithoutDocs'},
  {label:'ВОИД', value:'isVoid'},
  {label:'Подвязка', value:'tiedUp'},
  {label:'Комментарий подвязки', value:'tiedUpComment'},
  {label:'Номер ЕМД', value:'emdNumber'},
  {label:'КРС', value:'krs'},
  {label:'Альтернативный маршрут', value:'alternativeRoute'},
  {label:'Удалён', value:'isDeleted'}
]


const LogsModal = ({id, suppliers,currencies, model}) => {
  const [loading, setLoading] = useState(false)
  const [show, setShow]=useState(false)
  const [data, setData] = useState()
  const [activePage, setActivePage] = useState(0)
  const [pageData, setPageData] = useState()
  const [counterparties, setCounterparties] = useState()
  const formController = useForm()
  const {handleSubmit,
    register,
    reset,
  control} = formController

  const {
    field: { onChange: fieldOnChange, value: fieldValue }
  } = useController({
    name: `fieldName`,
    control,
    defaultValue: ''
  });

  const loadLogs = (query) =>{
    setLoading(true)
    axios.post("/api/logs/" +id,{query: query || {}, model},{headers: {...noDispHeader}})
      .then(({data})=>{
        setActivePage(0)
        console.log('data', data)
        setData(data.logs)
        setPageData(data.logs.slice(0,5))
      })
      .catch(sayError)
      .finally(()=>setLoading(false))
  }

  useEffect(() => {
    if(show && !counterparties){
      axios.post('/api/counterparty/searchInput')
        .then(({data})=>{
          setCounterparties(data.data)
        })
    }
    if(!show){
      setData()
      reset({fieldName: '',
        startDate:'',
        endDate:''})
    }else if(id && show && !data){
      loadLogs()
    }

  }, [id, show]);
  const onSubmitLogs = (data) =>{
    const sendingInfo = {}
    Object.keys(data).forEach(key=>{
      if(!!data[key]){
        sendingInfo[key] = data[key]
      }
    })
    loadLogs(sendingInfo)
  }

  const renderValue = (field) =>{
    if(typeof field.oldValue === 'number'){
      return <>
        <td>{numberFormat(field.oldValue)}</td>
        <td>{numberFormat(field.newValue)}</td>
      </>
    }else if( field.fieldName === 'supplierNew'){
      return <>
        <td>{_.find(suppliers, {value: field.oldValue})?.label || field.oldValue}</td>
        <td>{_.find(suppliers, {value: field.newValue})?.label || field.newValue}</td>
      </>
    }else if(field.fieldName === 'currency'){
      return <>
        <td>{_.find(currencies, {value: field.oldValue})?.label || field.oldValue}</td>
        <td>{_.find(currencies, {value: field.newValue})?.label || field.newValue}</td>
      </>
    }else if(field.fieldName === 'technicalCounterparty'){
      return <>
        <td>{_.find(counterparties, {value: field.oldValue})?.label || field.oldValue}</td>
        <td>{_.find(counterparties, {value: field.newValue})?.label || field.newValue}</td>
      </>
    }else if(typeof field.newValue === "boolean"){
      return <>
        <td>{field.oldValue ? "Да" : "Нет"}</td>
        <td>{field.newValue ? "Да" : "Нет"}</td>
      </>
    }else{
      return <>
        <td>{field.oldValue}</td>
        <td>{field.newValue}</td>
      </>
    }
  }

  if (id) {
    return (
      <>
        <div onClick={() => setShow(true)} style={{cursor: "pointer"}}>
          <i className="fa fa-comments"/>
        </div>
        <Modal show={show} onHide={() => setShow(false)} dialogClassName="modal-90w" >
          <Modal.Header closeButton>
            <Modal.Title>Изменения услуги</Modal.Title>
          </Modal.Header>
          <BlockUi blocking={loading}>
            <Modal.Body>
              <form onSubmit={handleSubmit(onSubmitLogs)} className={'d-flex gap-2 align-items-center justify-content-end mb-2'}>
                <div style={{width: '12rem'}}>
                  <SearchSelect
                    onChange={fieldOnChange}
                    defaultValue={fieldValue}
                    label={"Поля"}
                    array={[{value: '', label: 'Все'}, ...fields]}/>
                </div>
                <div>
                  <CustomDatePicker formController={formController}
                                    value={null}
                                    label={'Дата с'}
                                    name={'startDate'}
                  />
                </div>
                <div>
                  <CustomDatePicker formController={formController}
                                    value={null}
                                    label={'Дата по'}
                                    name={'endDate'}
                  />
                </div>
                <LoadingButton loading={loading} title={'Получить'} onClick={handleSubmit(onSubmitLogs)}/>
              </form>
              {data && counterparties && <Table bordered size={'sm'}>
                <thead>
                <tr>
                  <td style={{width:'2rem'}}>Ресурс</td>
                  <td>Дата</td>
                  <td>Изменил</td>
                  <td>Поле</td>
                  <td>Старое значение</td>
                  <td>Новое значение</td>
                </tr>
                </thead>
                <tbody>
                {pageData.map((item,index)=>{
                  return <React.Fragment key={index}>
                    <tr style={{backgroundColor: 'rgba(100,108,154,0.32)'}}>
                      <td>{item.source === 'site' ? 'Сайт' : '1C'}</td>
                      <td>{item.createdAt }</td>
                      <td colSpan={4}>{item.user}</td>
                  </tr>
                    {item.data.map((field, i)=>{
                      return <tr key={i}>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>{_.find(fields, {value: field.fieldName})?.label || field.fieldName}</td>
                        {renderValue(field)}
                      </tr>
                    })}
                  </React.Fragment>
                })}
                </tbody>

              </Table>}
              {data && data.length > 5 ? (
                <div className={'d-flex gap-2 align-items-center justify-content-end'}>
                  <Pagination
                    page={activePage}
                    totalPages={Math.ceil(data.length/5)}
                    callback={(e)=>{
                      const startPosition = (e * 5)
                      console.log('click', e)
                      setActivePage(e)
                      setPageData(data.slice(startPosition, startPosition+5))
                    }}
                  />
                </div>
              ) : null}
            </Modal.Body>
          </BlockUi>
        </Modal>
      </>
    );
  }

};

const mapStateToProps = ({misc}) => {
  const { currencies } = misc;
  return { currencies };
};

export default connect(mapStateToProps,{}) (LogsModal);
